import { Api } from '../../../redux/api/axiosInstance';

export interface PipelineStage {
  stage_id: number;
  name: string;
  display_name: string;
  color: string;
  bg_color: string;
  icon: string;
  stage_order: number;
  is_default: boolean;
  OrganizationID: number | null;
}

export interface CreatePipelineStagePayload {
  display_name: string;
  color?: string;
  bg_color?: string;
  icon?: string;
  stage_order?: number;
}

export type UpdatePipelineStagePayload = Partial<CreatePipelineStagePayload>;

export const getAllPipelineStages = async (): Promise<PipelineStage[]> => {
  const res = await Api.get('/pipeline-stages');
  return res.data.data ?? res.data;
};

export const createPipelineStage = async (
  payload: CreatePipelineStagePayload,
): Promise<PipelineStage> => {
  const res = await Api.post('/pipeline-stages', payload);
  return res.data.data ?? res.data;
};

export const updatePipelineStage = async (
  id: number,
  payload: UpdatePipelineStagePayload,
): Promise<PipelineStage> => {
  const res = await Api.put(`/pipeline-stages/${id}`, payload);
  return res.data.data ?? res.data;
};

export const deletePipelineStage = async (id: number): Promise<void> => {
  await Api.delete(`/pipeline-stages/${id}`);
};

export const reorderPipelineStages = async (stageIds: number[]): Promise<void> => {
  await Api.put('/pipeline-stages/reorder', { stageIds });
};
